import "./App.css";
import { useEffect, useState } from "react";

function App() {
  const [news, setNews] = useState([]);

  const categories = [
    "arts",
    "automobiles",
    "books",
    "business",
    "fashion",
    "food",
    "health",
    "home",
    "insider",
    "magazine",
    "movies",
    "nyregion",
    "obituaries",
    "opinion",
    "politics",
    "realestate",
    "science",
    "sports",
    "sundayreview",
    "technology",
    "theater",
    "t-magazine",
    "travel",
    "upshot",
    "us",
    "world",
  ];

  function handleCategoryClick(e) {
    window.scrollTo(0, 0);
    console.log(e.target.dataset.category);
    fetch(
      `https://api.nytimes.com/svc/topstories/v2/${e.target.dataset.category}.json?api-key=pN69PZ0mGPJn8tuOnApC7LU7fLJsq6jI`
    )
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        setNews(data.results);
      })
      .catch((error) => console.log(error.message));
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch(
      "https://api.nytimes.com/svc/topstories/v2/world.json?api-key=pN69PZ0mGPJn8tuOnApC7LU7fLJsq6jI"
    )
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        setNews(data.results);
      })
      .catch((error) => console.log(error.message));
  }, []);

  return (
    <>
      <h1 className="header">TODAY'S NEWS</h1>
      <div className="grid">
        <div className="sidebar">
          {categories.map((category) => (
            <button
              className="sidebar-button"
              data-category={category}
              onClick={handleCategoryClick}
            >
              {category}
            </button>
          ))}
        </div>
        <div className="container">
          {news &&
            news.map((article) => {
              console.log(
                "data",
                article?.["media"]?.[0]?.["media-metadata"]?.[1]?.["url"]
              );
              let url =
                article?.["multimedia"]?.[2]?.["url"] ||
                "https://via.placeholder.com/100";
              return (
                <div className="article">
                  <div className="article__content">
                    <h3 className="article__title">{article.title}</h3>
                    <p className="article__source">"NY Times"</p>
                    <p className="article__description">{article.abstract}</p>
                    <a
                      className="article__link"
                      href={article.url}
                      target="_blank"
                    >
                      Source
                    </a>
                  </div>
                  <div className="article__image-container">
                    <img className="article__image" src={url} alt="" />
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
}

export default App;

// "https://newsapi.org/v2/top-headlines?country=us&category=general&apiKey=69160c084382451a9d97b6a13451af0f"

/* 
pN69PZ0mGPJn8tuOnApC7LU7fLJsq6jI
45XBoTHb7uphzsfY

"https://via.placeholder.com/150"

"https://api.nytimes.com/svc/mostpopular/v2/viewed/1.json?api-key=pN69PZ0mGPJn8tuOnApC7LU7fLJsq6jI"

https://api.nytimes.com/svc/topstories/v2/books.json?api-key=pN69PZ0mGPJn8tuOnApC7LU7fLJsq6jI
https://api.nytimes.com/svc/topstories/v2/home.json?api-key=yourkey
https://api.nytimes.com/svc/topstories/v2/science.json?api-key=yourkey
https://api.nytimes.com/svc/topstories/v2/us.json?api-key=yourkey
https://api.nytimes.com/svc/topstories/v2/world.json?api-key=yourkey

 arts, automobiles, books, business, fashion, food, health, home, insider, magazine, movies, nyregion, obituaries, opinion, politics, realestate, science, sports, sundayreview, technology, theater, t-magazine, travel, upshot, us, and world.

*/
